import { render, staticRenderFns } from "./BestTransport.vue?vue&type=template&id=023c13d3&scoped=true&"
import script from "./BestTransport.vue?vue&type=script&lang=js&"
export * from "./BestTransport.vue?vue&type=script&lang=js&"
import style0 from "./BestTransport.vue?vue&type=style&index=0&id=023c13d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c13d3",
  null
  
)

export default component.exports